import { useDispatch } from 'react-redux';
import { useUserProfile } from './useUserProfile';
import { parseValidJSON } from './parseValidJSON';
import { setAnonymousRecentlyViewedProducts } from '../state/anonymousRecentlyViewedProducts/anonymousRecentlyViewedProducts';
import { useCallback } from 'react';

const useRecentlyViewedActions = () => {
  const dispatch = useDispatch();
  const { addViewedProduct } = useUserProfile();

  const saveRecentlyViewedProductAnonymously = useCallback(
    (productId) => {
      try {
        const dt = new Date();
        const viewingDate = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0));
        const recentlyViewedProducts = parseValidJSON(localStorage.getItem('rVP')) || [];
        const hasProductInList = recentlyViewedProducts.some((item) => item.productId === productId);

        if (!hasProductInList) {
          recentlyViewedProducts.push({ date: viewingDate.toISOString().substr(0, 10), productId });
        }

        const limitedRvp = recentlyViewedProducts.slice(-10);
        localStorage.setItem('rVP', JSON.stringify(limitedRvp));
        dispatch(setAnonymousRecentlyViewedProducts(limitedRvp));
      } catch (e) {
        console.error("Can't save RVP locally", e);
      }
    },
    [dispatch]
  );

  const saveRecentlyViewedProductToProfile = useCallback(
    (productId, profile) => {
      const hasRecentlyViewedProduct =
        profile?.recentlyViewedProducts &&
        profile.recentlyViewedProducts.some((product) => product.productId === productId);
      if (profile && !hasRecentlyViewedProduct) {
        addViewedProduct({
          body: JSON.stringify({ id: productId }),
        }).catch((reason) => {
          console.error("Can't save local rvp to profile:", reason);
        });
      }
    },
    [addViewedProduct]
  );

  return {
    saveRecentlyViewedProductToProfile,
    saveRecentlyViewedProductAnonymously,
  };
};

export default useRecentlyViewedActions;
